import axios from "axios";

function institutionSearch(objAux) {

	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3010"
			axios.get(process.env.ROOT_API  + "/institutions/search/" + objAux.id, {
				headers: {
					'Authorization': objAux.token
				}
			}).then(result => {
				resolve(result.data.documents[0])
			}).catch((error) => {
				reject(error.response.data.message)
			})
		} catch (error) {
			console.log('institutionSearch: ', error)
		}
	})
}
function institutionUpdate(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3009"
			axios.put(process.env.ROOT_API  + "/institutions/update/" + objAux.body.id, objAux.body, {
				headers: {
					Authorization: objAux.token
				}
			}).then(result => {
				resolve(result)
			}).catch(error => {
				reject(error.response.data.message)
			})
		} catch (error) {
			console.log('institutionUpdate: ', error)
		}
	})
}
function sendFile(arr, name, token) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3028"
		axios.put(process.env.ROOT_API  + "/store_file/" + name, arr, {
			headers: {
				'content-type': 'multipart/form-data',
				'Authorization': token
			}
		}).then(result => {
			resolve(result.data.documents[0])
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function getImage(id, token) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3027"
			axios.get(process.env.ROOT_API  + "/get_file/" + id, {
				responseType: 'blob',
				headers: {
					'content-type': 'multipart/form-data',
					'Authorization': token
				}
			})
				.then(result => {
					resolve(result)
				}).catch(error => {
					reject(error)
				})
		} catch (err) {
			console.log('err in Get Image: ', err);

		}
	})
}
function user_update(objAuxUser) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3017"
			axios.put(process.env.ROOT_API  + "/users/update/" + objAuxUser.id, {

				control: {
					updated_by: objAuxUser.update_by
				},
				logo: objAuxUser.logo
			}, {
					headers: {
						Authorization: objAuxUser.token
					}
				}).then(result => {
					resolve(result)
				}).catch(error => {
					reject(error.response.data.message)

				})
		} catch (error) {
			console.log('institutionUpdate: ', error)
		}
	})
}
function userSearch(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3016"
			axios.get(process.env.ROOT_API  + "/users/search/" + objAux.user, {
				headers: {
					'Authorization': objAux.token
				}
			}).then(result => {
				resolve(result.data.documents[0])
			}).catch(error => {
				reject(error.response.data.message)
			})
		} catch (error) {
			console.log('UserSearch: ', error)
		}
	})
}
function person_query(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3034"
			axios.put(process.env.ROOT_API  + "/persons/query",
				{
					email: objAux.email,
				},
				{
					headers:
					{
						'Authorization': objAux.token
					}
				}).then(result => {
					resolve(result.data.documents[0])
				}).catch(error => {
					reject(error.response.data.message)
				})
		} catch (error) {
			console.log('Person_Query: ', error)
		}
	})
}
function person_update(objAux) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3035"
			axios.put(process.env.ROOT_API  + "/persons/update/" + objAux.body.id, objAux.body, {
				headers:
				{
					Authorization: objAux.token
				}
			}).then(result => {
				resolve(result.data.documents[0])
			}).catch(error => {
				reject(error.response.data.message)
			})
		} catch (error) {
			console.log('Person_Query: ', error)
		}
	})
}
export {
	institutionSearch,
	institutionUpdate,
	sendFile,
	getImage,
	user_update,
	userSearch,
	person_query,
	person_update
};



// WEBPACK FOOTER //
// ./src/components/institution/easyFindMeServices.js